import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#333","color":"#fff","padding":"10px 20px"} }, [
  /*#__PURE__*/_createElementVNode("h3", null, "인감 변경 시 기존 인감은 삭제됩니다.")
], -1)
const _hoisted_3 = ["src"]

import { useStore } from 'vuex';
import axios from 'axios';
import { onMounted, ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCompSignImg',
  setup(__props) {

const store = useStore();
const dialog = ref(false);
const loading = ref(false);
const imageMiribogi = ref();
const imageFile = ref();
const ext = ref();
const imageType = ref();
const imageUrl = ref();
const imgName = ref();
const dialogOpen = async() => {
  dialog.value = true;
  imgName.value = store.state.AdminSisulCode + 'signImg';
  await fetchImage();
}
const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    const file = target.files[0];
    ext.value = file.name.split('.').pop();
    const reader = new FileReader();
    reader.onload = () => {
      imageMiribogi.value = reader.result;
    };
    reader.readAsDataURL(file);
    imageFile.value = file;
  }
};
const fetchImage = async () => {
  imageUrl.value = await getSisulSignImg();
};
const getSisulSignImg = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/api/getSisulSignImg/${imgName.value}`, { responseType: 'blob' });
    if(response.data){
      //인감타입 추출
      imageType.value = response.data.type.split('/')[1];
      if(imageType.value === 'jpeg'){
        imageType.value = 'jpg';
      }
      const imageBlob = response.data;
      const imageObjectURL = URL.createObjectURL(imageBlob);
      return imageObjectURL; // 가져온 인감 URL을 반환
    }
  } catch (error) {
    const imageObjectURL = 'nothing'
    return imageObjectURL;
  } finally {
    loading.value = false;
  }
};

const sendSisulSignImg = async () => {

if (!imageFile.value) {
  alert('인감 이미지를 선택하세요.');
  return;
}
const allowedTypes = ['image/jpeg', 'image/png'];
if (!allowedTypes.includes(imageFile.value.type)) {
  alert('JPG 또는 PNG 파일만 업로드 가능합니다.');
  loading.value = false;
  return;
}
loading.value = true;

try {
  if (imageUrl.value !== 'nothing') {
    await deleteSilsulSignImg();
  }
  const formData = new FormData();
  formData.append('image', imageFile.value);
  const response = await axios.post(`/api/sendSisulSignImg/${imgName.value}/${ext.value}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  if (response && response.data.success) {
    await fetchImage();
    dialog.value = false;
  } else {
    console.error('인감 업로드 실패', response.data);
  }
} catch (error) {
  console.error('인감 업로드 중 에러 발생', error);
} finally {
  loading.value = false;
}
};
const deleteSilsulSignImg = async () => {
try {
  const response = await axios.post(`/api/deleteSilsulSignImg/${imgName.value}`);
  if (!response) {
    alert('기존 파일 삭제 에러 발생.')
    return;
  }
} catch (error) {
  console.error('인감 업로드 중 에러 발생', error);
}
};
onMounted(async () => {
  imgName.value = store.state.AdminSisulCode + 'signImg';
  await fetchImage(); // 페이지 로드 시 이미지 URL 초기화
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogOpen())),
      style: {"width":"auto","height":"80px","cursor":"pointer"},
      src: imageMiribogi.value || imageUrl.value,
      alt: "인감"
    }, null, 8, _hoisted_1),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
      style: {"width":"400px"},
      class: "fontNotoSans400"
    }, {
      default: _withCtx(() => [
        (!loading.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        type: "file",
                        accept: "image/*",
                        onChange: handleFileUpload,
                        style: {"width":"100%","margin-bottom":"10px","border-bottom":"2px solid #333"}
                      }, null, 32)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: imageMiribogi.value || imageUrl.value,
                        alt: " 인감 확인 후 업로드버튼을 눌러주세요.",
                        style: {"max-width":"100%","max-height":"100%","margin-bottom":"5px"}
                      }, null, 8, _hoisted_3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  style: {"border-radius":"0 !important"},
                  onClick: sendSisulSignImg,
                  class: "btnColorBlue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("업로드")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  style: {"border-radius":"0 !important"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (dialog.value = false)),
                  class: "btnColorDark"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("닫기")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})